export const navButtonData = [
    {
        id: 1,
        label: "Products",
        path: "products"
    },
    {
        id: 2,
        label: "Signin",
        path: "signin"
    },
    {
        id: 3,
        label: "Contact",
        path: "contact"
    },
    {
        id: 4,
        label: "About",
        path: "about"
    },
    
]

export const navButtonHamburgerData = [
    {
        id: 1,
        label: "Home",
        path: "/"
    },
    {
        id: 2,
        label: "Products",
        path: "products"
    },
    {
        id: 3,
        label: "Signin",
        path: "signin"
    },
    {
        id: 4,
        label: "Contact",
        path: "contact"
    },
    {
        id: 5,
        label: "About",
        path: "about"
    },
]